import { Dropdown } from '../Dropdown';
import { FloatingField } from '../FloatingField';
import { FormCard } from '../FormCard';
import { FixedField, SelectShell } from './FloatingSelectField.styles';
import type { FloatingSelectFieldProps } from './FloatingSelectField.types';

export function FloatingSelectField({
  label,
  options,
  value,
  onChange,
  placeholder,
  required = true,
  error,
  fixedValueLabel,
  'aria-label': ariaLabel,
}: FloatingSelectFieldProps) {
  if (fixedValueLabel !== undefined) {
    return <FixedField aria-label={ariaLabel ?? label}>{fixedValueLabel}</FixedField>;
  }

  return (
    <SelectShell>
      <FormCard>
        <FloatingField label={label} hasValue={Boolean(value)} required={required} error={error}>
          <Dropdown
            options={options}
            value={value}
            placeholder={placeholder ?? (required ? `${label}*` : label)}
            onChange={onChange}
            aria-label={ariaLabel ?? label}
            hasError={Boolean(error)}
          />
        </FloatingField>
      </FormCard>
    </SelectShell>
  );
}
